import { render, staticRenderFns } from "./ProjectAssignmentInput.vue?vue&type=template&id=615ee56b"
import script from "./ProjectAssignmentInput.vue?vue&type=script&lang=js"
export * from "./ProjectAssignmentInput.vue?vue&type=script&lang=js"
import style0 from "./ProjectAssignmentInput.vue?vue&type=style&index=0&id=615ee56b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports